import { AppEvents } from '$scripts/events/events';
import { CriticalOutcome, Outcome } from '$scripts/outcome';
import { queryState as qs } from '$scripts/query-state';
import { createAccountAdobeUrl } from '$scripts/urls/list';
import { PROVIDERS } from '$shared/types/social-provider';
import { getApplicationState } from '$store/application-store';
import { defaultHandleRedirect } from '$traits/handlers';
import {
  GetOutcomes,
  RemainingOutcomes,
  outcomeFunction,
} from '$traits/helpers';
import { RedirectOutcome } from '$traits/outcomes';
import { convertError } from '@sentry/shared';

interface ActionDependencies {
  getApplicationState: typeof getApplicationState;
}

function createAction({ getApplicationState }: ActionDependencies) {
  return async function action() {
    try {
      const { events, queryState } = await getApplicationState();
      events.sendProvider(PROVIDERS.adobe);

      const url = createAccountAdobeUrl(qs.toObject(queryState))();
      return new RedirectOutcome({ url });
    } catch (e) {
      const error = convertError(e);
      return new CriticalOutcome(error);
    }
  };
}

export const outcomeAction = outcomeFunction(
  createAction({ getApplicationState })
);

export type TraitOutcome = GetOutcomes<typeof outcomeAction>;

export function handleOutcome<T extends Outcome>(
  events: AppEvents,
  outcome: T
) {
  defaultHandleRedirect(events, outcome);

  return outcome as RemainingOutcomes<T, TraitOutcome>;
}

export const trait = {
  action: outcomeAction,
  handle: handleOutcome,
};
